import Vue from "vue";
import App from "./App.vue";
import routes from "./router";
import store from "./store/index";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import 'vue-loading-overlay/dist/vue-loading.css';
// font awesome
import "vue-awesome/icons";
// Import TinyMCE
import tinymce from "tinymce/tinymce";

// Default icons are required for TinyMCE 5.3 or above
import "tinymce/icons/default";

// A theme is also required
import "tinymce/themes/silver";

// Any plugins you want to use has to be imported
import "tinymce/plugins/paste";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/advlist";

// Initialize the app
tinymce.init({
  selector: "#tiny",
  plugins: ["paste", "link", "advlist", "lists"],
  toolbar: "numlist bullist",
  advlist_bullet_styles: "circle"
});

Vue.component("tinymce", tinymce);
import VueUploadComponent from 'vue-upload-component';
Vue.component('file-upload', VueUploadComponent);
Vue.use(require("vue-moment"));
Vue.config.productionTip = false;
Vue.config.silent = true
// configure router
const router = new VueRouter({
  base: process.env.BASE_URL,
  routes, // short for routes: routes
  mode: "history"
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.state.Login.token) {
      // let vuex = JSON.parse(window.localStorage.getItem('vuex'));
      // Service.AuthAPI.getUserDetail(store.state.Login.token).then((res) => {
      //   vuex.Login.userDetail = res;
      //   window.localStorage.setItem('vuex', JSON.stringify(vuex))
      // });
      next();
    } else {
      window.localStorage.removeItem("vuex");
      next('login')
      // window.location = `${process.env.BASE_URL}login`
    }
  } else {
    next(); // make sure to always call next()!
  }
});
//style scss
import "./assets/css/variables.scss";
import "./assets/css/font.scss";
import "./main.scss";
import "./assets/css/switch.css";
import VueRouter from "vue-router";
import Service from "./Services";
/* eslint-disable */
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

